import { RootState } from '../app/state'
import { Answer } from '../state/interfaces'

export enum AnswersProviders {
  PHONES_BRANDS = 'phones:brands',
}

export type AnswersProviderWithOptions = { provider: AnswersProviders; options?: Record<string, unknown> }

export type AnswersProvider = (state: RootState, options?: Record<string, unknown>) => Promise<Array<Answer>>
